import { useMemo } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { SectionHeader } from '@cox/core-ui8/dist/SectionHeader'

import { ReactSectionHeaderProps } from './types'
import withAEM from '../../hoc/withAEM'
import { useInversionData } from '../../hooks/useInversionData'
import { getInversionTokenValues } from '../../utils/inversion-util'

const ReactSectionHeader = (props: ReactSectionHeaderProps): JSX.Element => {
  const { eyebrow, description, title, hideMCP = false, isInEditor = false } = props
  const inversionItems = useInversionData()
  const { appData } = useAppDataContext()
  const isLocal = appData?.page?.isLocal
  const invTokenregex = /\[\[(?!token|offer)[^\]]+\]\]/g
  const newItems = useMemo(() => inversionItems, [inversionItems])

  const getText = (item: any) => {
    if (item && typeof item === 'string') {
      return item
    }
    return item?.value
  }

  const getValue = (item: any) => {
    const itemText = getText(item)
    if (isLocal && invTokenregex.test(itemText)) {
      const matches = itemText?.match(invTokenregex)
      let tokenReplacedString: any = itemText
      tokenReplacedString = matches?.reduce((acc: string, invToken: string) => {
        return acc.replace(invToken, () => {
          return getInversionTokenValues(invToken, newItems) ?? ''
        })
      }, itemText)
      return { value: tokenReplacedString, isRTE: true, ...item }
    }
    return { value: itemText, isRTE: true, ...item }
  }

  const SectionHeaderWithAEM = withAEM(SectionHeader)
  return (
    <SectionHeaderWithAEM
      {...props}
      eyebrow={getValue(eyebrow)}
      title={getValue(title)}
      description={getValue(description)}
      hideMCP={hideMCP}
      isInEditor={isInEditor}
      compName={'Section Header'}
    />
  )
}
export default ReactSectionHeader
